import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Previews Button'
export const group = ''

export default class ElPreviewsButton extends SectionProvider {
  constructor (options = {}) {
    super('ElPreviewsButton', options)

    this.name = name
    this.group = group
  }
}